import { Injectable } from "@angular/core";
import { HttpService } from './http.service';
import { DPO_CONSTANT } from '../utils/constant';

// Subscription Service to handle subscription screen APIs
@Injectable()
export class SubscriptionService {

    constructor(private httpService: HttpService) { }

    // Method to call a API for subscription features
    public getSubscribedFeatures(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.SUBSCRIPTION_FEATURES + queryParams;
        return this.httpService.get(finalUrl);
    }

    // Method to call a API for save subscription features
    public saveSubscription(body: any) {
        const finalUrl = DPO_CONSTANT.SUBSCRIPTION_SAVE;
        return this.httpService.post(finalUrl, body);
    }

    // Method to call a API for RRDI search engine
    public getRrdiByEngine(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.SUBSCRIPTION_RRDI_SEARCH + queryParams;
        return this.httpService.get(finalUrl);
    }

    // Method to call a API for getting the warranty campaign info
    public getWarrantyAndCampaign(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.SUBSCRIPTION_WARRANTY_CAMPAIGN_INFO + queryParams;
        return this.httpService.get(finalUrl);
    }

    // Method to call a API for getting the current subsciptions
    public getCurrentSubscription(params: any) {
        const queryParams = this.httpService.prepareQueryParams(params);
        const finalUrl = DPO_CONSTANT.SUBSCRIPTION_CURRENT + queryParams;
        return this.httpService.get(finalUrl);
    }

}